import { Drawer, styled } from '@mui/material'
import { isGlobalworth } from 'config'

export const ListContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flex: 1,
  padding: '12px',
}))

export const DRAWER_WIDTH = 223

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: '60%',
    margin: '85px 0px 0px 20px',
    borderRadius: isGlobalworth ? '0px' : '10px',
    color: theme.palette.primary.light,
    [theme.breakpoints.up('sm')]: {
      width: DRAWER_WIDTH,
      height: 'calc(100vh - 110px)',
    },
    boxSizing: 'border-box',
    '@media (max-width:1550px)': {
      paddingTop: '65px',
      margin: 0,
      borderRadius: 0,
      width: DRAWER_WIDTH,
      height: '100%',
    },
  },

  '& .MuiListItem-root.expanded': {
    backgroundColor: theme.palette.grey[100],
    borderRadius: '10px',
    '& .MuiListItemButton-root': {
      backgroundColor: 'transparent',
    },
  },

  '& li:nth-last-child(3), & li:nth-last-child(2)': {
    '& path': {
      stroke: isGlobalworth && theme.palette.primary.main,
    },
  },

  '& svg': {
    width: isGlobalworth ? '24px' : 'unset',
  },

  '& svg > rect.cls-1, & svg > rect.cls-2': {
    display: isGlobalworth ? 'none' : 'block',
  },
}))
